export type TitleType = "movie" | "tv";

export interface TitleItem {
  id: string;
  title: string;
  en: string;
  type: TitleType;
  year: number;
  region: string;
  genres: string[];
  rating: number;
  duration: string;
  director: string;
  cast: string[];
  releaseDate: string;
  summary: string;
  tags: string[];
  heat: number;
  updatedAt: string;
  poster: string;
  featured?: boolean;
}

export const titles: TitleItem[] = [
  {
    id: "deep-sea-echo",
    title: "深海回声",
    en: "Echoes of the Deep",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["悬疑", "剧情"],
    rating: 8.7,
    duration: "128 分钟",
    director: "沈牧之",
    cast: ["周砚川", "林知夏", "许南乔", "贺行舟"],
    releaseDate: "2024-11-08",
    summary:
      "一支深海科考队在万米海沟录到一段不属于任何已知生物的低频回声。随着解码推进，队长发现这段声音与二十年前失踪的科考船日志高度吻合，一场关于记忆与真相的深潜就此展开。",
    tags: ["深海", "悬念反转", "高口碑"],
    heat: 9860,
    updatedAt: "2025-09-28",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20lone%20diver%20silhouette%20descending%20into%20deep%20midnight%20ocean%20with%20pale%20light%20shafts%20and%20drifting%20particles%2C%20moody%20navy%20and%20teal%20palette%2C%20no%20text%2C%20premium%20film%20key%20art&width=600&height=900&seq=mv-01&orientation=portrait",
    featured: true,
  },
  {
    id: "long-night-coming",
    title: "长夜将至",
    en: "The Long Night",
    type: "movie",
    year: 2025,
    region: "中国香港",
    genres: ["犯罪", "悬疑", "动作"],
    rating: 8.2,
    duration: "134 分钟",
    director: "区朗生",
    cast: ["陈启铭", "何念安", "麦子谦"],
    releaseDate: "2025-06-20",
    summary:
      "雨夜、旧区、断电。三个互不相识的人在同一个夜晚被卷入一桩悬案，而唯一的线索，是一段被反复擦除的行车记录。天亮之前，他们必须决定谁在说谎。",
    tags: ["港式犯罪", "雨夜", "群像"],
    heat: 9210,
    updatedAt: "2025-10-02",
    poster:
      "https://readdy.ai/api/search-image?query=Neo%20noir%20film%20poster%20of%20a%20solitary%20figure%20with%20umbrella%20on%20a%20rain%20soaked%20Hong%20Kong%20street%20at%20night%2C%20neon%20reflections%20on%20wet%20asphalt%2C%20deep%20navy%20and%20amber%20tones%2C%20no%20text%2C%20cinematic%20key%20art&width=600&height=900&seq=mv-02&orientation=portrait",
    featured: true,
  },
  {
    id: "harbor-in-fog",
    title: "雾港往事",
    en: "Harbor in Fog",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["剧情", "年代", "家庭"],
    rating: 8.9,
    duration: "142 分钟",
    director: "苏景和",
    cast: ["李培之", "程蔚", "宋晚舟", "傅川"],
    releaseDate: "2023-09-15",
    summary:
      "一座南方港口小城，三代人的迁徙与留守。父亲把半生的秘密留在废弃的仓库里，女儿在整理遗物时，才慢慢读懂那个被雾气笼罩的年代。",
    tags: ["年代质感", "家庭", "口碑佳作"],
    heat: 8640,
    updatedAt: "2025-08-19",
    poster:
      "https://readdy.ai/api/search-image?query=Atmospheric%20period%20drama%20film%20poster%20showing%20an%20old%20fishing%20harbor%20wrapped%20in%20thick%20morning%20fog%20with%20wooden%20boats%20and%20weathered%20warehouses%2C%20muted%20blue%20grey%20palette%2C%20no%20text%2C%20elegant%20composition&width=600&height=900&seq=mv-03&orientation=portrait",
    featured: true,
  },
  {
    id: "stardust-traveler",
    title: "星尘旅人",
    en: "Stardust Traveler",
    type: "movie",
    year: 2024,
    region: "美国",
    genres: ["科幻", "冒险", "剧情"],
    rating: 8.4,
    duration: "146 分钟",
    director: "Elias Vane",
    cast: ["Noah Reed", "Mira Cole", "Julian Hart"],
    releaseDate: "2024-07-26",
    summary:
      "在最后一次星际迁跃中，领航员意外与地面失去联系。他带着一段残破的语音记录穿越三颗行星，只为把一句话送到十二年前的地球。",
    tags: ["硬科幻", "太空", "催泪"],
    heat: 9420,
    updatedAt: "2025-09-30",
    poster:
      "https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20movie%20poster%20of%20a%20small%20astronaut%20silhouette%20standing%20before%20an%20enormous%20ringed%20planet%2C%20cool%20navy%20blue%20and%20soft%20violet%20light%2C%20vast%20scale%2C%20no%20text%2C%20cinematic%20key%20art&width=600&height=900&seq=mv-04&orientation=portrait",
  },
  {
    id: "letters-in-april",
    title: "四月的信",
    en: "Letters in April",
    type: "movie",
    year: 2022,
    region: "日本",
    genres: ["爱情", "剧情"],
    rating: 8.6,
    duration: "118 分钟",
    director: "小林遥",
    cast: ["森川葵", "高桥悠真", "中村千夏"],
    releaseDate: "2022-04-09",
    summary:
      "旧书店的老板每年四月都会收到一封没有署名的信。第七年，写信的人终于出现在门口，却只问了一句：你还记得那年春天的雨吗？",
    tags: ["日式纯爱", "治愈", "慢节奏"],
    heat: 7980,
    updatedAt: "2025-07-11",
    poster:
      "https://readdy.ai/api/search-image?query=Soft%20romantic%20Japanese%20film%20poster%20of%20a%20young%20woman%20reading%20letters%20by%20a%20window%20with%20cherry%20blossoms%20outside%2C%20gentle%20morning%20light%2C%20pale%20blue%20and%20cream%20palette%2C%20no%20text%2C%20delicate%20composition&width=600&height=900&seq=mv-05&orientation=portrait",
  },
  {
    id: "beyond-the-dunes",
    title: "沙丘之外",
    en: "Beyond the Dunes",
    type: "movie",
    year: 2025,
    region: "美国",
    genres: ["科幻", "史诗", "冒险"],
    rating: 8.1,
    duration: "156 分钟",
    director: "Caleb Stone",
    cast: ["Rowan Pike", "Ada Ferreira", "Sam Okafor"],
    releaseDate: "2025-03-14",
    summary:
      "沙海深处的补给站即将关闭，两名测绘员必须徒步穿越三百公里的无人区。当水耗尽，他们开始怀疑地图上那条不存在的路线，是前人留下的求救信号。",
    tags: ["沙海美学", "生存", "视听大片"],
    heat: 9030,
    updatedAt: "2025-10-05",
    poster:
      "https://readdy.ai/api/search-image?query=Sweeping%20desert%20epic%20movie%20poster%20of%20two%20tiny%20figures%20walking%20across%20immense%20sand%20dunes%20at%20golden%20hour%2C%20deep%20amber%20and%20navy%20shadow%20palette%2C%20minimal%20composition%2C%20no%20text%2C%20cinematic&width=600&height=900&seq=mv-06&orientation=portrait",
  },
  {
    id: "chasing-the-wind",
    title: "追风少年",
    en: "Chasing the Wind",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["运动", "青春", "剧情"],
    rating: 7.9,
    duration: "112 分钟",
    director: "郭子恒",
    cast: ["韦亦然", "沈小鱼", "骆明远"],
    releaseDate: "2023-08-04",
    summary:
      "小城少年想参加一场没有年龄分组的环岛自行车赛。没有教练、没有装备，他只有一辆改装过的旧车和一条每天骑三十公里的海岸公路。",
    tags: ["热血", "公路", "成长"],
    heat: 7120,
    updatedAt: "2025-06-22",
    poster:
      "https://readdy.ai/api/search-image?query=Youthful%20sports%20film%20poster%20of%20a%20teenage%20cyclist%20riding%20along%20a%20coastal%20road%20at%20dusk%2C%20motion%20blur%2C%20ocean%20horizon%20behind%2C%20warm%20orange%20sky%20with%20deep%20blue%20shadows%2C%20no%20text&width=600&height=900&seq=mv-07&orientation=portrait",
  },
  {
    id: "silent-testimony",
    title: "无声证词",
    en: "Silent Testimony",
    type: "movie",
    year: 2024,
    region: "韩国",
    genres: ["犯罪", "惊悚", "悬疑"],
    rating: 8.5,
    duration: "126 分钟",
    director: "박정우",
    cast: ["김도현", "이서연", "최민재"],
    releaseDate: "2024-05-17",
    summary:
      "一桩没有目击者的案件，唯一的证人是位听障清洁工。她的证词在法庭上被质疑，而她记住的，是凶手袖口那枚不合时宜的纽扣。",
    tags: ["法庭", "反转", "社会派"],
    heat: 8890,
    updatedAt: "2025-09-12",
    poster:
      "https://readdy.ai/api/search-image?query=Tense%20crime%20thriller%20poster%20of%20a%20dark%20interrogation%20room%20with%20a%20single%20hanging%20lamp%20casting%20harsh%20light%20on%20an%20empty%20chair%2C%20cold%20steel%20blue%20tones%2C%20no%20text%2C%20high%20contrast&width=600&height=900&seq=mv-08&orientation=portrait",
  },
  {
    id: "above-the-snowline",
    title: "雪线以上",
    en: "Above the Snowline",
    type: "movie",
    year: 2021,
    region: "中国大陆",
    genres: ["冒险", "剧情", "家庭"],
    rating: 8.0,
    duration: "131 分钟",
    director: "罗青山",
    cast: ["谭野", "季雪", "段一鸣"],
    releaseDate: "2021-12-03",
    summary:
      "一对多年未见的父子在登山队重逢。父亲是向导，儿子是随队摄影师。当暴风雪提前到来，他们必须在雪线以上做出同一个决定。",
    tags: ["登山", "父子", "自然"],
    heat: 6540,
    updatedAt: "2025-05-08",
    poster:
      "https://readdy.ai/api/search-image?query=Adventure%20drama%20poster%20of%20two%20climbers%20on%20a%20knife%20edge%20snow%20ridge%20in%20high%20altitude%20whiteout%2C%20cold%20blue%20and%20pale%20grey%20palette%2C%20immense%20mountain%20scale%2C%20no%20text%2C%20cinematic&width=600&height=900&seq=mv-09&orientation=portrait",
  },
  {
    id: "last-metro-paris",
    title: "巴黎最后一班",
    en: "The Last Metro",
    type: "movie",
    year: 2022,
    region: "法国",
    genres: ["爱情", "喜剧"],
    rating: 7.8,
    duration: "104 分钟",
    director: "Camille Rousseau",
    cast: ["Léa Bernard", "Théo Marchand", "Anaïs Petit"],
    releaseDate: "2022-10-21",
    summary:
      "错过末班地铁的两个人，在巴黎的深夜决定用一整夜走回各自的街区。他们约定天一亮就互相忘记，却把电话号码写在了同一张车票上。",
    tags: ["法式浪漫", "一夜", "轻松"],
    heat: 6230,
    updatedAt: "2025-04-26",
    poster:
      "https://readdy.ai/api/search-image?query=Charming%20French%20romantic%20comedy%20poster%20of%20an%20elegant%20woman%20with%20a%20suitcase%20on%20an%20empty%20metro%20platform%20at%20night%2C%20warm%20lamplight%20and%20deep%20blue%20surroundings%2C%20no%20text%2C%20cinematic&width=600&height=900&seq=mv-10&orientation=portrait",
  },
  {
    id: "the-man-in-the-mirror",
    title: "镜中之人",
    en: "The Man in the Mirror",
    type: "movie",
    year: 2025,
    region: "英国",
    genres: ["心理", "悬疑", "惊悚"],
    rating: 8.3,
    duration: "121 分钟",
    director: "Harriet Lowe",
    cast: ["Oliver Grant", "Sophie Dean", "Mark Ellis"],
    releaseDate: "2025-02-28",
    summary:
      "一位睡眠治疗师发现自己的病人描述的场景，与他自己从未告诉过任何人的梦境完全一致。更可怕的是，镜子里的人开始比他早起三分钟。",
    tags: ["心理惊悚", "高概念", "细节控"],
    heat: 8760,
    updatedAt: "2025-09-25",
    poster:
      "https://readdy.ai/api/search-image?query=Psychological%20thriller%20poster%20of%20a%20fractured%20mirror%20reflecting%20a%20blurred%20male%20profile%20in%20a%20dim%20room%2C%20shards%20floating%20in%20cold%20blue%20light%2C%20no%20text%2C%20moody%20and%20minimal&width=600&height=900&seq=mv-11&orientation=portrait",
  },
  {
    id: "old-days-in-the-hill-city",
    title: "山城旧事",
    en: "Old Days in the Hill City",
    type: "movie",
    year: 2020,
    region: "中国大陆",
    genres: ["剧情", "家庭"],
    rating: 8.8,
    duration: "137 分钟",
    director: "何宗平",
    cast: ["严复生", "陶慧", "小小舟"],
    releaseDate: "2020-11-13",
    summary:
      "山城的老街要拆了，一间开了四十年的面馆只剩下最后一个月。老板娘每天多煮一碗面，等着那个说会回来的人。",
    tags: ["市井", "烟火气", "高分"],
    heat: 7410,
    updatedAt: "2025-03-16",
    poster:
      "https://readdy.ai/api/search-image?query=Nostalgic%20Chinese%20drama%20poster%20of%20a%20steep%20old%20stone%20stairway%20alley%20in%20a%20misty%20mountain%20city%20with%20warm%20lit%20noodle%20shop%20windows%2C%20rain%20slick%20steps%2C%20muted%20teal%20and%20amber%2C%20no%20text&width=600&height=900&seq=mv-12&orientation=portrait",
  },
  {
    id: "letter-beyond-lightyear",
    title: "光年之外的信",
    en: "A Letter Beyond Lightyears",
    type: "movie",
    year: 2024,
    region: "美国",
    genres: ["科幻", "爱情"],
    rating: 7.7,
    duration: "115 分钟",
    director: "Nina Park",
    cast: ["Ethan Vale", "Clara Wynn", "Ben Ortiz"],
    releaseDate: "2024-12-06",
    summary:
      "她在地球，他在四点二光年外的空间站。所有的对话都延迟八年。当她说出那句等了太久的话，收到的回复来自一个已经不存在的人。",
    tags: ["星际", "异地", "细腻"],
    heat: 6890,
    updatedAt: "2025-08-02",
    poster:
      "https://readdy.ai/api/search-image?query=Poetic%20sci%20fi%20romance%20poster%20of%20two%20hands%20reaching%20toward%20each%20other%20across%20a%20field%20of%20distant%20stars%2C%20deep%20navy%20space%20with%20soft%20warm%20light%20between%20fingertips%2C%20no%20text%2C%20dreamy&width=600&height=900&seq=mv-13&orientation=portrait",
  },
  {
    id: "end-of-the-rails",
    title: "铁轨尽头",
    en: "End of the Rails",
    type: "movie",
    year: 2023,
    region: "德国",
    genres: ["战争", "剧情"],
    rating: 8.4,
    duration: "139 分钟",
    director: "Klaus Brenner",
    cast: ["Lukas Meyer", "Ingrid Falk", "Jonas Weber"],
    releaseDate: "2023-02-17",
    summary:
      "1945 年的冬天，一名铁路信号员被要求让一列不该存在的车通过。他在雪里守了三个夜晚，等来的却是自己多年前的学生。",
    tags: ["二战", "人性", "冷静叙事"],
    heat: 7010,
    updatedAt: "2025-02-09",
    poster:
      "https://readdy.ai/api/search-image?query=Somber%20period%20war%20drama%20poster%20of%20an%20abandoned%20railway%20track%20vanishing%20into%20snowy%20forest%20fog%2C%20a%20single%20signal%20lamp%20glowing%20red%2C%20desaturated%20blue%20grey%20palette%2C%20no%20text&width=600&height=900&seq=mv-14&orientation=portrait",
  },
  {
    id: "summer-screening-room",
    title: "夏日放映厅",
    en: "The Summer Screening Room",
    type: "movie",
    year: 2022,
    region: "中国台湾",
    genres: ["青春", "剧情"],
    rating: 8.2,
    duration: "107 分钟",
    director: "林晏如",
    cast: ["许安", "周予晴", "陈柏宇"],
    releaseDate: "2022-07-15",
    summary:
      "小镇上唯一的老影院要关门了，四个高中生决定在暑假结束前，放完那卷从未公开的胶片。而那卷胶片里，有他们十年前的自己。",
    tags: ["夏天", "影院", "温柔"],
    heat: 6670,
    updatedAt: "2025-07-29",
    poster:
      "https://readdy.ai/api/search-image?query=Nostalgic%20coming%20of%20age%20poster%20of%20a%20small%20vintage%20neighborhood%20cinema%20with%20glowing%20marquee%20on%20a%20summer%20evening%2C%20bicycles%20parked%20outside%2C%20warm%20amber%20light%20and%20dusk%20blue%20sky%2C%20no%20text&width=600&height=900&seq=mv-15&orientation=portrait",
  },
  {
    id: "zero-hour-operation",
    title: "零点行动",
    en: "Zero Hour Operation",
    type: "movie",
    year: 2025,
    region: "中国大陆",
    genres: ["动作", "警匪"],
    rating: 7.6,
    duration: "124 分钟",
    director: "邵天野",
    cast: ["雷震", "蒋澈", "温亦然"],
    releaseDate: "2025-07-18",
    summary:
      "零点整，全城的信号同时中断。一支临时组建的小队只有六小时找回控制权，而他们中最沉默的那个人，正是这场行动的起因。",
    tags: ["都市动作", "限时", "燃"],
    heat: 8320,
    updatedAt: "2025-10-08",
    poster:
      "https://readdy.ai/api/search-image?query=High%20octane%20action%20thriller%20poster%20of%20a%20special%20forces%20silhouette%20against%20a%20dark%20city%20skyline%20with%20red%20and%20blue%20emergency%20lights%20streaking%20through%20rain%2C%20no%20text%2C%20cinematic&width=600&height=900&seq=mv-16&orientation=portrait",
  },
  {
    id: "dark-river-trail",
    title: "暗河迷踪",
    en: "Trail of the Dark River",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["悬疑", "犯罪", "剧情"],
    rating: 8.9,
    duration: "全 24 集",
    director: "钟启明",
    cast: ["裴斯远", "温岚", "宋嘉禾", "韩青"],
    releaseDate: "2024-10-11",
    summary:
      "一条穿城而过的地下暗河，连续三年出现同一处异常水位。刑警队长与地质学者在追查一起失踪案时，发现整座城市的防洪图被人为修改过。",
    tags: ["刑侦", "群像", "年度剧王"],
    heat: 9950,
    updatedAt: "2025-10-10",
    poster:
      "https://readdy.ai/api/search-image?query=Gritty%20crime%20series%20poster%20of%20a%20detective%20with%20flashlight%20inside%20a%20vast%20underground%20brick%20tunnel%20with%20dark%20water%2C%20single%20beam%20of%20light%2C%20deep%20navy%20and%20rust%20palette%2C%20no%20text&width=600&height=900&seq=tv-01&orientation=portrait",
    featured: true,
  },
  {
    id: "ferry-of-long-wind",
    title: "长风渡口",
    en: "Ferry of the Long Wind",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["古装", "剧情", "年代"],
    rating: 8.5,
    duration: "全 40 集",
    director: "顾行舟",
    cast: ["谢明澜", "白露生", "沈砚"],
    releaseDate: "2023-06-08",
    summary:
      "渡口是这条江上唯一的通关之处。一个守渡人、一位落难书生、一队北上的商旅，在二十年的风云里反复相遇，也反复告别。",
    tags: ["古装正剧", "江湖", "质感"],
    heat: 9110,
    updatedAt: "2025-09-18",
    poster:
      "https://readdy.ai/api/search-image?query=Elegant%20ancient%20Chinese%20drama%20poster%20of%20a%20misty%20river%20ferry%20crossing%20at%20dawn%20with%20a%20cloaked%20figure%20standing%20on%20the%20prow%2C%20distant%20mountains%2C%20ink%20wash%20blue%20and%20gold%20palette%2C%20no%20text&width=600&height=900&seq=tv-02&orientation=portrait",
  },
  {
    id: "city-glimmer",
    title: "城市微光",
    en: "Glimmer in the City",
    type: "tv",
    year: 2025,
    region: "中国大陆",
    genres: ["都市", "情感", "职场"],
    rating: 8.1,
    duration: "全 32 集",
    director: "陆知遥",
    cast: ["苏黎", "程亦白", "罗小满"],
    releaseDate: "2025-04-19",
    summary:
      "四个住在同一栋旧楼的年轻人，各自在深夜的城市里奔跑。他们共享一部坏掉的电梯、一个天台，以及一段谁都不愿先开口的温柔。",
    tags: ["都市群像", "治愈", "共情"],
    heat: 8790,
    updatedAt: "2025-10-01",
    poster:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20poster%20of%20four%20young%20people%20on%20a%20city%20rooftop%20at%20night%20looking%20at%20warm%20lit%20windows%20of%20apartment%20blocks%2C%20deep%20navy%20sky%20with%20soft%20amber%20glow%2C%20no%20text&width=600&height=900&seq=tv-03&orientation=portrait",
  },
  {
    id: "foggy-capital-files",
    title: "雾都档案",
    en: "The Foggy Capital Files",
    type: "tv",
    year: 2022,
    region: "英国",
    genres: ["悬疑", "年代", "犯罪"],
    rating: 8.7,
    duration: "全 8 集",
    director: "Amelia Clarke",
    cast: ["Thomas Hale", "Eleanor Voss", "Rory Black"],
    releaseDate: "2022-11-27",
    summary:
      "1889 年的伦敦，一名女法医在一具无名尸体上发现了自己丈夫的手术缝合手法。她决定在雾散之前，把整座城市的体面翻过来。",
    tags: ["英伦", "推理", "短剧"],
    heat: 7560,
    updatedAt: "2025-08-14",
    poster:
      "https://readdy.ai/api/search-image?query=Victorian%20mystery%20series%20poster%20of%20a%20fog%20filled%20London%20cobblestone%20street%20with%20gas%20lamps%20and%20a%20woman%20in%20a%20long%20coat%20holding%20a%20lantern%2C%20muted%20teal%20grey%20and%20amber%2C%20no%20text&width=600&height=900&seq=tv-04&orientation=portrait",
  },
  {
    id: "twenty-four-hour-er",
    title: "二十四小时急诊",
    en: "24 Hour ER",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["医疗", "职场", "剧情"],
    rating: 8.3,
    duration: "全 28 集",
    director: "程安然",
    cast: ["顾向南", "叶青禾", "郑一舟"],
    releaseDate: "2024-03-15",
    summary:
      "城市中心医院急诊科的一整个夜晚，从接班到天亮。每一小时都有新的推床进来，而每个人都在用自己的方式，撑住别人的最后一分钟。",
    tags: ["医疗", "夜班", "真实感"],
    heat: 8110,
    updatedAt: "2025-09-05",
    poster:
      "https://readdy.ai/api/search-image?query=Medical%20drama%20poster%20of%20a%20long%20empty%20hospital%20corridor%20at%20night%20with%20cool%20fluorescent%20light%20and%20a%20distant%20warm%20glow%20from%20the%20operating%20room%2C%20deep%20teal%20blue%20palette%2C%20no%20text&width=600&height=900&seq=tv-05&orientation=portrait",
  },
  {
    id: "the-northern-visitor",
    title: "北方来客",
    en: "The Northern Visitor",
    type: "tv",
    year: 2023,
    region: "美国",
    genres: ["剧情", "惊悚"],
    rating: 8.0,
    duration: "全 10 集",
    director: "Grace Holloway",
    cast: ["Owen Marsh", "Nora Finch", "Dean Alvar"],
    releaseDate: "2023-01-20",
    summary:
      "暴雪封路的第七天，一座只有十二户人家的小镇来了一个陌生人。他带着一张全镇人的合照，说这张照片是在十年后拍的。",
    tags: ["小镇悬疑", "雪景", "氛围"],
    heat: 7340,
    updatedAt: "2025-07-04",
    poster:
      "https://readdy.ai/api/search-image?query=Snowy%20small%20town%20mystery%20poster%20of%20a%20lonely%20log%20cabin%20in%20the%20forest%20with%20one%20warm%20lit%20window%20and%20deep%20snow%2C%20a%20distant%20solitary%20figure%20approaching%2C%20cold%20blue%20palette%2C%20no%20text&width=600&height=900&seq=tv-06&orientation=portrait",
  },
  {
    id: "interstellar-outpost",
    title: "星际前哨",
    en: "Interstellar Outpost",
    type: "tv",
    year: 2025,
    region: "美国",
    genres: ["科幻", "冒险", "剧情"],
    rating: 8.6,
    duration: "全 12 集",
    director: "Marcus Vale",
    cast: ["Iris Nolan", "Caleb Wu", "Sasha Brant"],
    releaseDate: "2025-05-09",
    summary:
      "前哨站只有六个人和一台年久失修的 AI。当补给船第三次失约，他们开始怀疑：那颗蓝色行星上的信号，其实一直在回应他们。",
    tags: ["太空站", "AI", "高概念"],
    heat: 9580,
    updatedAt: "2025-10-09",
    poster:
      "https://readdy.ai/api/search-image?query=Sleek%20science%20fiction%20series%20poster%20of%20a%20small%20orbital%20space%20station%20silhouetted%20against%20a%20giant%20blue%20planet%20with%20thin%20sun%20flare%2C%20deep%20navy%20and%20cyan%20palette%2C%20minimal%20premium%20design%2C%20no%20text&width=600&height=900&seq=tv-07&orientation=portrait",
    featured: true,
  },
  {
    id: "night-of-mountains-and-seas",
    title: "山海幻夜",
    en: "Night of Mountains and Seas",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["奇幻", "古装", "冒险"],
    rating: 7.9,
    duration: "全 36 集",
    director: "楚玄清",
    cast: ["云舒", "江照白", "阿岚"],
    releaseDate: "2024-08-23",
    summary:
      "古籍修复师在一卷残破的山海图里，看见了自己童年丢失的名字。为了找回它，她必须在天亮之前，走完图上标注的七座山。",
    tags: ["东方奇幻", "视觉系", "冒险"],
    heat: 8470,
    updatedAt: "2025-09-22",
    poster:
      "https://readdy.ai/api/search-image?query=Eastern%20fantasy%20series%20poster%20of%20glowing%20mythical%20mountain%20peaks%20with%20floating%20lanterns%20and%20a%20lone%20figure%20holding%20a%20scroll%2C%20teal%20blue%20night%20with%20warm%20gold%20light%20accents%2C%20no%20text%2C%20epic&width=600&height=900&seq=tv-08&orientation=portrait",
  },
];

export const genreOptions = [
  "悬疑",
  "犯罪",
  "剧情",
  "科幻",
  "爱情",
  "动作",
  "古装",
  "都市",
  "奇幻",
  "惊悚",
  "家庭",
  "青春",
  "冒险",
  "医疗",
  "战争",
  "年代",
  "喜剧",
  "运动",
  "史诗",
  "心理",
  "职场",
  "情感",
];

export const regionOptions = [
  "中国大陆",
  "中国香港",
  "中国台湾",
  "美国",
  "日本",
  "韩国",
  "英国",
  "法国",
  "德国",
];

export const yearOptions = [2025, 2024, 2023, 2022, 2021, 2020];